(function () {
  var DRAG_STEP_PX = 55;

  function initSpinHero(root) {
    var frames = Array.prototype.slice.call(root.querySelectorAll('[data-spin-frame]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-spin-dot]'));
    var labelEl = root.querySelector('[data-spin-label]');
    if (!frames.length) return;

    var labels = frames.map(function (frame) {
      return frame.getAttribute('alt').split(', ').slice(1).join(', ') || 'front';
    });

    var frameCount = frames.length;
    var currentIndex = 0;
    var dragging = false;
    var startX = 0;
    var activePointerId = null;

    function setActiveFrame(index) {
      currentIndex = ((index % frameCount) + frameCount) % frameCount;
      frames.forEach(function (frame, i) {
        frame.classList.toggle('is-active', i === currentIndex);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
      if (labelEl) {
        labelEl.textContent = labels[currentIndex];
      }
    }

    function onPointerDown(event) {
      dragging = true;
      startX = event.clientX;
      activePointerId = event.pointerId;
      root.classList.add('is-dragging');
      try {
        root.setPointerCapture(activePointerId);
      } catch (e) {}
    }

    function onPointerMove(event) {
      if (!dragging) return;
      var totalDelta = event.clientX - startX;
      var steps = Math.trunc(totalDelta / DRAG_STEP_PX);
      if (steps !== 0) {
        setActiveFrame(currentIndex + steps);
        startX = event.clientX;
      }
    }

    function endDrag() {
      dragging = false;
      root.classList.remove('is-dragging');
      if (activePointerId !== null) {
        try {
          root.releasePointerCapture(activePointerId);
        } catch (e) {}
      }
      activePointerId = null;
    }

    root.addEventListener('pointerdown', onPointerDown);
    root.addEventListener('pointermove', onPointerMove);
    root.addEventListener('pointerup', endDrag);
    root.addEventListener('pointercancel', endDrag);
    root.addEventListener('pointerleave', function () {
      if (dragging) endDrag();
    });

    setActiveFrame(0);
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-spin-hero]');
    roots.forEach(initSpinHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-spin-hero]');
    if (root) initSpinHero(root);
  });
})();
